module.exports = __webpack_public_path__ + "static/media/package.b587d7fd.png";